export const videoTypes = {
  Youtube: 0,
  Vimeo: 1,
  Facebook: 2,
  Dailymotion: 3,
  properties: {
    0: { name: 'Youtube', value: 0, code: 'YOUTUBE_VIDEOS' },
    1: { name: 'Vimeo', value: 1, code: 'VIMEO_VIDEOS' },
    2: { name: 'Facebook', value: 2, code: 'FACEBOOK_VIDEOS' },
    3: { name: 'Dailymotion', value: 3, code: 'DAILYMOTION_VIDEOS' }
  }
}